import newsletterHeadlines from '../../../images/dashboard-images/newsletter_headlines.png'
import newsletterContentAreas from '../../../images/dashboard-images/newsletter-content-areas.png'
import newsletterColors from '../../../images/dashboard-images/newsletter-colors.png'
import newsletterMovieSelection from '../../../images/dashboard-images/newsletter-movie-selection.png'
import newsletterDragDrop from '../../../images/dashboard-images/newsletter-drag-drop.png'

const UpdateItem22Mai2024 = ({date, lastUpdate, onClick, activeUpdateText, id}) => {
    const additionalClass = lastUpdate ? 'update-text-open' : activeUpdateText === id ? 'update-text-open' : 'update-text-close' 
    return (
        <div className={"" + additionalClass}>
            {onClick ? (<p onClick={()=>onClick(additionalClass, id)} className="update-title cursor-pointer title-large-color gap-10">{date}</p>)
            :
            (<p className="title-large-color gap-10">{date}</p>)}
            <div className="update-text-content">
                <p className="text-regular-color text-regular-uppercase">
                    NEUE NEWSLETTER FEATURES / NEW NEWSLETTER FEATURES
                </p>
                <div className='gap-35'>
                    <p className="text-regular gap-10">
                         Im Backoffice konfigurierbare Newsletter um Themen-Newsletter wie "Filme für Kinder" mit individuellen Inhaltsbereichen und Farben zu ermöglichen.   
                        <br/><br/>
                        <span className='grey'>
                            Configurable Newsletters in the back office to enable themed newsletters such as “Movies for Children” with individual content areas and colors.
                        </span>
                    </p>
                    <br/><br/>
                    <div>
                        <p className="text-regular gap-10">
                            Optionale Konfiguration der Inhaltsbereiche<br/>
                            <span className='grey'>Optional configuration of content areas</span>
                        </p>
                        <img width="700px" src={newsletterContentAreas}/>
                    </div>
                    <br/><br/>
                    <div>
                        <p className="text-regular gap-10">
                            Anpassung der Überschriften<br/>
                            <span className='grey'>Adjustment of headings</span>
                        </p>
                        <img width="700px" src={newsletterHeadlines}/>
                    </div>
                    <br/><br/>
                    <div>
                        <p className="text-regular gap-10">
                        Individuelle Gestaltung für jeden Newsletter im Backoffice.<br/>
                            <span className='grey'>Individual design for each newsletter in the back office.</span>
                        </p>
                        <img width="700px" src={newsletterColors}/>
                    </div>
                    <br/><br/>
                    <p className="text-regular uppercase orange gap-10">
                        Newsletter einfacher bearbeiten<br/>
                        <span className='grey'>Easier edit newsletters</span>
                    </p>
                    <div>
                        <p className="text-regular gap-10">
                            Filter zur Auswahl der Filme für den Newsletter<br/>
                            <span className='grey'>Filter for selecting movies for the newsletter</span>
                            
                        </p>
                        <img width="700px" src={newsletterMovieSelection}/>
                    </div>
                    <br/><br/>
                    <div>
                        <p className="text-regular gap-10">
                            Sortierung der Newsletter-Inhalte per Drag & Drop<br/>
                            <span className='grey'>Sorting the newsletter content via drag & drop</span>
                            
                        </p>
                        <img width="700px" src={newsletterDragDrop}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateItem22Mai2024